module.exports = __webpack_public_path__ + "img/catstagram-details4.f2a09bb9.png";